import fetch from '@updater-core/lib/fetch';
import { ENVIRONMENT } from '@updater-core/lib/environment';
import { updaterEventFromEvent } from '../utils';
import { VERBS } from '../constants';

export function eventstreamTrack(configFn) {
  const { url, app, authorization, accessToken, client, uid } = configFn();

  return (event, parentSpan) => {
    if (!(VERBS.includes(event.verb) && url)) return undefined;

    return fetch(url, {
      method: 'POST',
      mode: 'cors',
      headers: {
        App: app,
        Authorization: authorization,
        'Site-Origin': window.location.href,
        'Access-token': accessToken,
        'Content-type': 'application/json',
        client,
        uid,
      },
      redirect: 'follow',
      referrer: 'no-referrer',
      body: JSON.stringify({ updater: updaterEventFromEvent(event) }),
      parentSpan,
    }).catch((error) => {
      if (ENVIRONMENT?.debug?.eventTracker) {
        // eslint-disable-next-line no-console
        console.error('[ERROR] - event stream track failed', event, error);
      }
    });
  };
}
